// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21D0q","fullView":"styles_fullView__264Qk"};